import React, { useEffect } from "react";
import { useQuery, useQueries } from 'react-query'
import { getResultRSC_H2H } from "data/Querys"
import Loader from 'components/general/Loader'
import { findArray, filterArray } from 'helpers/utils'
import NotAvailable from "components/common/NotAvailable";
import Referees from "components/general/Referees";
import PageHeader from "components/common/PageHeader";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { getEvent } from "helpers/rsc"
import KteScore from "components/sports/kte/views/KteScore";
import KtePbp from "components/sports/kte/views/KtePbp";
import KteKata from "components/sports/kte/views/KteKata";

const KteContext = () => {
  const { mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
  let isKata = false;
  if (getEvent(mirs_rsc) === 'KATA--------------') {
    isKata = true;
  }
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  //datos para el marcador y estadisticas
  const { data, isError, isLoading } = useQuery(
    {
      queryKey: ['resultsDataH2H', mirs_competition, mirs_rsc, mirs_language],
      queryFn: getResultRSC_H2H,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      //enabled: !!confCategory
    });

  //load to subMatches
  let queryArray = [];

  //Filter matches from parent match
  let subMatches = data && filterArray(data?.results?.extendedInfos, { ei_type: ['TEAM'], ei_code: ['COMP'] });
  subMatches = subMatches && subMatches.sort((a, b) => a.ei_pos - b.ei_pos);

  subMatches && subMatches.forEach((match) => {
    queryArray.push({
      queryKey: ['resultsDataH2H', mirs_competition, match.ei_value, mirs_language],
      queryFn: getResultRSC_H2H,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
    })
  });

  const matches = useQueries(queryArray);//Data all maches
  const isLoadingAll = isLoading || matches.some(match => match.isLoading)
  const isErrorAll = isError || matches.some(match => match.isError)

  if (isLoadingAll) { return <Loader />; }
  if (isErrorAll) { return <NotAvailable />; }

  return (
    <>
      {data?.results ? (
        <>
          <PageHeader data={data} />
          <div className='mirs-page-container'>
          {isKata ?
            <KteKata data={data} />
            : <>
              <div className='my-5'>
                <KteScore data={data} />
              </div>
              <div>
                <KtePbp data={data} />
                <Referees data={data?.results?.officials} />
              </div>
            </>}
          </div>
        </>
      ) : (
        <NotAvailable />
      )
      }
    </>
  );
};

export default KteContext;